import { render, staticRenderFns } from "./MoveItem.vue?vue&type=template&id=bc47cf24&"
import script from "./MoveItem.vue?vue&type=script&lang=js&"
export * from "./MoveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports